import React from 'react';

import {EMPTY_SEARCH_RESULT_PROPS} from 'notebook/mediocre/search/SearchResultProps';
import SelectableNotePart from 'notebook/mediocre/selection/block/SelectableNotePart';
import {INDENT_SIZE} from 'notebook/notes/lists/ListConstants';
import {RowCountText} from 'notebook/tables/collapse/RowCountText';
import TableTitleBar from 'notebook/tables/core-ui/TableTitleBar';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {TableCollapserContext} from 'ui-library/tables/TableCollapserContext';

import {TableIndicatorStatus} from '../TableConstants';

export interface AlwaysCollapsedTableProps {
  icon: BenchlingIconName;
  numRows?: number;
  indentation: number;
  tableTypeLabel?: string;
  tableName: string;
  tooltipText: string;
  selectable?: boolean;
}

/**
 * Component that represents a collapsed table that can't be expanded.
 */
export function AlwaysCollapsedTable({
  icon,
  numRows,
  indentation,
  tableTypeLabel,
  tableName,
  tooltipText,
  selectable = true,
}: AlwaysCollapsedTableProps): JSX.Element {
  const rawTitleBar = (
    <TableTitleBar
      rightHeaderControls={<RowCountText numRows={numRows} />}
      icon={icon}
      isFocused={false}
      isTableMaximized={false}
      isTableSplitScreen={false}
      isTableExpanded={false}
      disableMaximize={true}
      useRoundedBottomBorder={true}
      tableIndentationPx={indentation * INDENT_SIZE}
      forceRightPadding={true}
      tableTypeLabel={tableTypeLabel}
      tableName={tableName}
      shouldRenderCollapserChevron={false}
      usePointerCursor={false}
      tooltipText={tooltipText}
      status={TableIndicatorStatus.NO_STATUS}
      {...EMPTY_SEARCH_RESULT_PROPS}
    />
  );
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values -- Disabling for now, but worth fixing
    <TableCollapserContext.Provider value={{isTableInitiallyCollapsed: true}}>
      {selectable ? (
        <SelectableNotePart indentation={indentation}>{rawTitleBar}</SelectableNotePart>
      ) : (
        rawTitleBar
      )}
    </TableCollapserContext.Provider>
  );
}
